import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(errorResponse => {
            // if (errorResponse.status === 401) {
            //     // auto logout if 401 response returned from api
            //     this.authenticationService.logout();
            //     location.reload(true);
            // }

            let error: any;

            // todo: should be refactored and also added other cases
            if (errorResponse.error) {
                if (errorResponse.error.errors) {
                    if (errorResponse.error.errors.DomainValidations)
                        error = Array.isArray(errorResponse.error.errors.DomainValidations)
                            ? errorResponse.error.errors.DomainValidations.join('; ')
                            : errorResponse.error.errors.DomainValidations
                    else
                        error = errorResponse.error.errors;
                }
                else
                    error = errorResponse.error
            }
            else
                error = errorResponse.message;
            return throwError({ message: error });
        }))
    }
}